export default "__VITE_ASSET__BbhWdlhR__"